import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { AccionDetalle, IInitialState } from '../../Shared/data/FormReducer';
import { Dropzone, FileMosaic, VideoPreview } from '@dropzone-ui/react';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';
import { useRef } from 'react';
import toast from 'react-hot-toast';
import { Tr4inerContainedButton } from '../../Utils/Button';
import LoadingAllScreen from '../../Components/LoadingAllScreen/LoadingAllScreen';
import { sendVideoUsuario, subirVideoService } from '../../Services/Form';
import { useNavigate } from 'react-router-dom';
import { IUserFromStorage } from '../../Interfaces/IUser';
import axios from 'axios';
import { urlApiAsesoria } from '../../Config/baseUrl';

import CloseIcon from '@mui/icons-material/Close';
import { convertMovToMp4, DropzoneFile, getVideoDuration, loadFFmpeg } from './constants';


interface Props {
  state: IInitialState;
  dispatch: Dispatch<AccionDetalle>;
}

const UploadVideo = ({ state, dispatch }: Props) => {

  const ffmpegRef = useRef(new FFmpeg());
  const [ffmpegLoaded, setFfmpegLoaded] = useState(false);
  const [isConverting, setIsConverting] = useState(false);
  const [conversionProgress, setConversionProgress] = useState(0);
  const [videoFile, setVideoFile] = useState<any>(null);
  const [videoUrl, setVideoUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();
  
  useEffect(() => {    
    //* Cargar FFmpeg (llamar una vez al montar el componente)
    loadFFmpeg(ffmpegRef, setFfmpegLoaded);
  }, []);

  // useEffect(() => {
  //   console.log(videoFile, 'Video File');
  //   console.log(videoUrl, 'Video URL');

  // }, [videoFile, videoUrl])

  const updateVideoFile = async (incomingFiles: DropzoneFile[]): Promise<void> => {
    //* Limpiar si no hay archivos
    if (incomingFiles.length === 0) {
      if (videoUrl) URL.revokeObjectURL(videoUrl);
      setVideoUrl('');
      setVideoFile(null);
      return;
    }

    //* Solo tomar el primer archivo
    const e = incomingFiles[0];
    
    //* Bloquear si ya hay conversión en proceso
    if (isConverting) {
      toast.error('Ya hay un video en proceso. Espera a que termine.');
      return;
    }

    //* Si ya hay un video cargado, limpiar el anterior
    if (videoFile) {
      if (videoUrl) URL.revokeObjectURL(videoUrl);
      toast.success('Video anterior reemplazado');
    }

    //* Advertir si intentaron subir más de 1
    if (incomingFiles.length > 1) {
      toast.error('Solo puedes subir 1 video. Se tomó el primero.');
    }
    
    //* Validar que el archivo sea válido
    if (!e || e.valid !== true) {
      setVideoUrl('');
      setVideoFile(null);
      return;
    }

    let file = e.file;

    //* Validar formato
    if (file.type !== 'video/mp4' && file.type !== 'video/quicktime') {
      toast.error('El archivo debe ser formato MP4 o MOV.');
      setVideoUrl('');
      setVideoFile(null);
      return;
    }

    //* Validar tamaño
    if (file.size >= 100 * 1024 * 1024) {
      toast.error('El video es demasiado grande (máx 100 MB).');
      setVideoUrl('');
      setVideoFile(null);
      return;
    }

    //* Validar duración
    try {
      const duration = await getVideoDuration(file);
      
      if (duration > 30) {
        toast.error(`El video excede los 30 segundos (duración: ${Math.round(duration)}s).`);
        setVideoUrl('');
        setVideoFile(null);
        return;
      }
    } catch (error) {
      toast.error('Error al leer el video.');
      setVideoUrl('');
      setVideoFile(null);
      return;
    }

    //* Convertir MOV a MP4 
    if (file.type === 'video/quicktime') {
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(1);
      const toastId = toast.loading(`Convirtiendo video (${sizeInMB} MB)... 0%`);
      
      try {
        setIsConverting(true);
        
        const ffmpeg = ffmpegRef.current;
        
        const progressHandler = ({ progress }: { progress: number }): void => {
          const percent = Math.round(progress * 100);
          setConversionProgress(percent);
          toast.loading(`Convirtiendo video a MP4... ${percent}%`, { id: toastId });
        };
        
        ffmpeg.on('progress', progressHandler);
        
        file = await convertMovToMp4(file, ffmpegLoaded, ffmpegRef);
        
        ffmpeg.off('progress', progressHandler);
        
        // const newSizeMB = (file.size / (1024 * 1024)).toFixed(1);
        toast.success(`¡Video convertido exitosamente!`, { id: toastId });
        
      } catch (error) {
        console.error('Error:', error);
        toast.error('Error al convertir el video', { id: toastId });
        setIsConverting(false);
        setVideoUrl('');
        setVideoFile(null);
        return;
      } finally {
        setIsConverting(false);
        setConversionProgress(0);
      }
    }

    try {
      const newVideoUrl = URL.createObjectURL(file);
      const finalDuration = await getVideoDuration(file);
      
      const updatedFile: DropzoneFile = {
        ...e,
        file,
        videoUrl: newVideoUrl,
        duration: finalDuration,
      };
      
      setVideoUrl(newVideoUrl);
      setVideoFile(updatedFile);

    } catch (error) {
      toast.error('Error al procesar el video.');
      setVideoUrl('');
      setVideoFile(null);
    }
  };

  const uploadVideoFunction = () => {
    if (!videoFile) {
      toast.error('No hay video para subir');
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append('Video', videoFile.file, videoFile.file.name);
    formData.append('UsuarioTestAsesoriaID', user.usuarioTestAsesoriaID.toString());

    console.log('Tamaño:', (videoFile.file.size / (1024 * 1024)).toFixed(2), 'MB');

    sendVideoUsuario(
      formData
    )
      .then(() => {
        toast.success('Video enviado correctamente.');
        setVideoFile(null);
        if (videoUrl) {
          URL.revokeObjectURL(videoUrl);
          setVideoUrl('');
        }
        navigate('/despuesTest');
      })
      .catch((error) => {
        toast.error('Hubo un error al subir video, por favor intente nuevamente más tarde.');
        console.error('Error al subir video:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div>
      {( isLoading || !ffmpegLoaded )&& (
        <div className="absolute bg-slate-500/30 top-0 w-full min-h-[100dvh]">
          <LoadingAllScreen />
        </div>
      )}
      <div className="my-2 font-bold mt-3">
        <div className="flex flex-row justify-around">
          <div className="box invisible"></div>
          <b className="text-orangeTr4iner text-2xl">Sube tu video</b>
          <button title='Ir a Perfil'>
            <CloseIcon sx={{fontSize: '30px'}} onClick={() => navigate('/perfil')} /> 
          </button>
        </div>

        <div className="flex flex-col items-center justify-center w-max m-auto">
          {' '}
          <div className="mt-3 flex justify-start items-center w-full">
            <span className="h4 font-bold text-left">1&nbsp;</span>
            Sosteniendo el mismo cartel
          </div>
          <div className="flex justify-start items-center w-full">
            <span className="h4 font-bold">2&nbsp;</span>
            Grabándote de cuerpo completo (de cabeza a pies)
          </div>
          <div className="flex justify-start items-center w-full">
            <span className="h4 font-bold ">3&nbsp;</span>
            Frente a una pared clara y con buena iluminación
          </div>
          <div className="justify-start items-left w-full flex flex-col">
            <div className='w-full flex items-center'>
              <span className="h4 font-bold">4&nbsp;</span>
              Debes girar lentamente mostrando 4 posiciones:
            </div>
            <ul className="list-disc ml-4 items-start flex flex-col justify-start">
              <li>De frente</li>
              <li>De perfil derecho</li>
              <li>De perfil izquierdo</li>
              <li>De espalda</li>
            </ul>
          </div>
           
          <div className="flex justify-start items-center w-full">
            <span className="h4 font-bold ">5&nbsp;</span>
            El video debe durar máximo 30 segundos
          </div>
        </div>
      </div>

      <div className="m-1 mt-2 mb-3 font-bold">
        <strong>Nota:</strong>  Al terminar de convertir el video, podrás enviarlo.
      </div>
      <div className="lg:w-[70%] w-[80%] m-auto">
        <Dropzone
          onChange={updateVideoFile}
          accept="video/mp4,video/quicktime"
          maxFiles={1}
          label="Arrastra tu video aquí (MP4 o MOV, máx 30s)"
          minHeight="195px"
          value={videoFile ? [videoFile] : []}
          disabled={isConverting}
        >
          {videoFile && (
            <FileMosaic {...videoFile} preview />
          )}
        </Dropzone>
      </div>
      <Tr4inerContainedButton
        variant="contained"
        style={{
          fontWeight: 'bold',
          textTransform: 'inherit',
          margin: '1rem 0',
        }}
        disabled={videoFile === null || isConverting && videoFile}
        onClick={uploadVideoFunction}
      >
        Enviar
      </Tr4inerContainedButton>
    </div>
  );
};

export default UploadVideo;
